<template>
    <card-list>

        <container-list-item padded no-border>
            <b-field label="Title" label-position="inside">
                <b-input v-model="certification.title"></b-input>
            </b-field>
        </container-list-item>

        <!-- Course category management moved to the v2 portal (Content >
             Courses). The section that lived here created categories against
             certification_certs ids and violated the FK on every attempt. -->

    </card-list>
</template>

<script>
    import CardList from "@/TIER/components/CardList";
    import ContainerListItem from "@/TIER/components/ContainerListItem";

    export default {
        name: 'CertificationForm',
        props: {
            certification: {
                type: Object,
                required: true
            },
        },
        components: {ContainerListItem, CardList},
    };
</script>
